import { Smartphone, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const installPromptStorageKey = (userId) => `pc_web_app_guide_prompt_dismissed:${userId}`;

export function isStandaloneWebApp(windowObj = window, navigatorObj = navigator) {
  return Boolean(navigatorObj?.standalone || windowObj?.matchMedia?.("(display-mode: standalone)")?.matches);
}

export function shouldShowInstallPrompt(userId, windowObj = window, navigatorObj = navigator) {
  if (!userId || isStandaloneWebApp(windowObj, navigatorObj)) return false;
  return windowObj.localStorage.getItem(installPromptStorageKey(userId)) !== "true";
}

export default function PlayerAppInstallPrompt({ userId }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(() => shouldShowInstallPrompt(userId));
  if (!visible) return null;
  const dismiss = () => {
    window.localStorage.setItem(installPromptStorageKey(userId), "true");
    setVisible(false);
  };
  const openGuide = () => { dismiss(); navigate("/hilfe/web-app"); };
  return <aside className="fixed z-40 left-3 right-3 max-w-sm mx-auto pc-card p-3.5" style={{ bottom: "calc(var(--pc-player-bottom-nav-height, 76px) + var(--pc-player-floating-control-gap, 28px))", boxShadow: "0 18px 60px rgba(0,0,0,.4)" }} role="dialog" aria-label="Performance Care zum Home-Bildschirm hinzufügen" data-testid="player-app-install-prompt">
    <div className="flex items-start gap-3"><div className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: "var(--pc-cyan-dim)", color: "var(--pc-cyan)" }}><Smartphone size={20} /></div><div className="min-w-0 flex-1"><strong className="block font-display">Performance Care zum Home-Bildschirm hinzufügen</strong><p className="text-sm mt-1" style={{ color: "var(--pc-muted)" }}>Dauert ca. 1 Minute.</p></div><button type="button" aria-label="Später" className="p-1" onClick={dismiss}><X size={17} /></button></div>
    <div className="flex gap-2 mt-3"><button type="button" className="pc-btn pc-btn-primary" style={{ padding: "9px 14px", fontSize: 13 }} onClick={openGuide}>Anleitung öffnen</button><button type="button" className="pc-btn pc-btn-ghost" style={{ padding: "9px 14px", fontSize: 13 }} onClick={dismiss}>Später</button></div>
  </aside>;
}
